<template>
    <div>
        <div class="modal fade" id="paymentModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">WeBase Subscription</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">
                        <payment-form @subscribeSuccessful="onSubscribeSuccess"></payment-form>
                    </div>
                    <div class="modal-footer">
<!--                        <button type="button" class="btn btn-primary" @click="yesHandler" >Ok</button>-->
                        <button type="button" class="btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import PaymentForm from "./PaymentForm.vue";
    import UserService from "../services/UserService";
    export default {
        name: 'PaymentModal',
        components: {PaymentForm},
        props: {
            yesEvent: Function
        },
        data () {
            return {
                model: webase.model,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            // add an event to trigger the parent's "noEvent" once the modal has been hidden
            // $('#paymentModal').on('hidden.bs.modal', () => {
            //     this.$emit('noEvent')
            // })
            // // show the modal
            // $('#paymentModal').modal('show')
            this.modalElement = document.getElementById('paymentModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()
        },
        beforeUnmount() {
            // remove the event
            // $('#paymentModal').off('hidden.bs.modal')
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                // hide the modal
                this.currentModal.hide()
            },
            yesHandler() {
                // call the parent's "yesEvent"
                if(this.yesEvent) {
                    this.yesEvent()
                }
                // hide the modal
                this.noHandler()
            },
            onSubscribeSuccess() {
                // TODO need to update the customer
                let service = new UserService()
                service.current()
                this.yesHandler()
            }
        }
    }
</script>
